import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonFunction } from 'src/app/grievance/common-function';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { AssignedObjectionSuggestionListService } from './assigned-objection-suggestion-list.service';

const COLS = [
  { value: "OBJECTION/SUGGESTION ID", lowercaseValue: "pkOsid", displayName: "Objection/Suggestion Id" },
  { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
  { value: "CREATED DATE", lowercaseValue: "createdOn", displayName: "Created Date" },
  { value: "Objection/Suggestion TYPE", lowercaseValue: "uosType", displayName: "Objection/Suggestion Type" },
  { value: "SUBJECT", lowercaseValue: "osSubject", displayName: "Subject" },
  { value: "STATUS", lowercaseValue: "statusName", displayName: "Status" },

];



export class ObjectionSuggestionList {
  pkOsid: any;
  boardName: any;
  departmentName: any;
  osTypeName: string;
  uosType: any
  osSubject: any
  objectionSuggestion: any;
  createdOn: any;
  statusName: any
}
@Component({
  selector: 'app-assigned-objection-suggestion-list',
  templateUrl: './assigned-objection-suggestion-list.component.html',
  styleUrls: ['./assigned-objection-suggestion-list.component.scss'],
})
export class AssignedObjectionSuggestionListComponent implements OnInit {
  displayedCols = COLS;
  allCols = COLS;
  displayedColumns: any[];
  objectionSuggestionList: ObjectionSuggestionList[] = [];
  dataSource = new MatTableDataSource(this.objectionSuggestionList);
  progressSpinnerDialog: any = null;
  filterForm: FormGroup = new FormGroup({});
  objectionNoData = ProjectConstants.objectionNotAvailable
  // @ViewChild(MatPaginator)
  // set paginator(value: MatPaginator) {
  //   this.dataSource.paginator = value;
  // }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  pageSize: any;
  pageSizeOptions: number[] = [10, 20, 50];
  currentPage: any;
  pageIndex: any;
  pageEvent: PageEvent;
  totalRows = 0;
  previousUrl: string = null;
  currentUrl: string = null;
  previousRoute: string;
  constructor(public supportUserGrievanceService: AssignedObjectionSuggestionListService,
    public datepipe: DatePipe,
    private commonFunction: CommonFunction,
    public dialog: MatDialog,
    public router: Router,
  ) { }

  async ngOnInit() {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required])
    });
    var index = localStorage.getItem("PageIndex")
    if (index == null) {
      this.currentPage = Number(localStorage.setItem("PageIndex", "0"))

    } else {
      this.currentPage = Number(localStorage.getItem("PageIndex"))
    }
    var size = localStorage.getItem("PageSize")
    if (size == null) {
      this.pageSize = Number(localStorage.setItem("PageSize", "10"))

    } else {
      this.pageSize = Number(localStorage.getItem("PageSize"))
    }
    this.displayedCols = [
      { value: "OBJECTION/SUGGESTION ID", lowercaseValue: "pkOsid", displayName: "Objection/Suggestion Id" },
      { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
      { value: "CREATED DATE", lowercaseValue: "createdOn", displayName: "Created Date" },
      { value: "Objection/Suggestion TYPE", lowercaseValue: "uosType", displayName: "Objection/Suggestion Type" },
      { value: "SUBJECT", lowercaseValue: "osSubject", displayName: "Subject" },
      { value: "STATUS", lowercaseValue: "statusName", displayName: "Status" },
    ];
    this.dataSource.paginator = this.paginator;
    this.displayedColumns = this.displayedCols.map((col) => col.value);
    this.loadObjectionSuggestions();
  }


  async loadObjectionSuggestions() {
    this.displayProgressSpinner();
    this.objectionSuggestionList = []
    const response1: any = await this.supportUserGrievanceService.objectionSuggestionListV2(this.currentPage, this.pageSize);
    this.progressSpinnerDialog.close()
    if (response1 != null && !response1.error) {
      if (response1.content.length != 0) {
        const response: any = response1.content
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          for (var i = 0; i < response.length; i++) {
            // var created_date = response[i].createdOn
          var created_date = (response[i].createdOn!=null && response[i].createdOn.includes("+"))?response[i].createdOn.split("+")[0]:response[i].createdOn

            let created_on = this.datepipe.transform(created_date, 'dd/MM/yyyy hh:mm:a');
            const customObj = new ObjectionSuggestionList();
            customObj.pkOsid = response[i].pkOsid
            customObj.boardName = response[i].boardName
            customObj.uosType = this.text_truncate(response[i].uosType, 30, '....')
            customObj.osTypeName = this.text_truncate(response[i].osTypeName, 30, '....');
            customObj.createdOn = created_on
            customObj.statusName = response[i].statusName
            customObj.osSubject = this.text_truncate(response[i].osSubject, 30, '....');//response[i].osSubject;
            this.objectionSuggestionList.push(customObj)
          }
          this.dataSource.data = this.objectionSuggestionList;
          setTimeout(() => {
            this.paginator.length = response1.totalElements;
          });
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        this.objectionSuggestionList = []
      }
    } else {
      this.objectionSuggestionList = []
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      this.dataSource.data = this.objectionSuggestionList;
    }
    this.displayedColumns = this.displayedCols.map((col) => col.value);
  }

  async getServerData(event?: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.currentPage = this.pageIndex
    localStorage.setItem("PageIndex", this.currentPage);
    localStorage.setItem("PageSize", this.pageSize);
    this.loadObjectionSuggestions();
  }

  //objection and suggestion subject truncate function
  text_truncate(str, length, ending) {
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  }
  //

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }


  // go to assigned objection suggestion view
  goToObjectionSuggestionView(objectionSuggestionId: any) {
    this.router.navigate(['secure/view-assigned-objection-suggestion/' + objectionSuggestionId])
  }
  //





  applyFilter(search: any) {
    const filterValue = search;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    const filterValue = ''
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
